import debug from 'debug';

export const log = debug('terralego:Auth');

export default log;
